import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import moment from 'moment';
import { getStartOfDayLocalFromUTC } from 'Helpers/DateTime';

export function useYearPicker({
  startDateField,
  isAge,
  yearLabel,
  dateLabel,
  dateValue,
  dateOnChange,
  granularity = 'month',
}) {
  // Figure out the start date
  const { resource } = useMetaLayoutContext();
  const startDateStr = resource.attr(startDateField);
  if (!startDateStr) {
    return undefined; // There shouldn't be any year picker
  }
  // Date.jsx normally handles calling getStartOfDayLocalFromUTC for the UI, but here we need to call it ourselves because we'll be feeding values from here to the date picker via dateOnChange.
  // The startOf is to fix a bug - if your birthday is January 2nd, 2000, and you pick 01/2001, we'd expect the age to be 1, even though on January 1st 2001 you wouldn't yet be 1 year old, so we need to make your birthday look like January 1st 2000 here
  const startDate = moment(getStartOfDayLocalFromUTC(startDateStr)).startOf(granularity);

  // Come up with the dateOnChange handler for the year input
  const onYearChange = (val) => {
    const numericVal = +val;
    const hasValue = Number.isNaN(numericVal) || val === null; // +null === 0 which is why we are explicitly checking for null here
    if (hasValue) {
      return dateOnChange(undefined);
    }
    return dateOnChange(moment(startDate).add(numericVal, 'years').toISOString());
  };

  // Compute a label for this field
  let label = yearLabel;
  if (!label) {
    label = dateLabel;
    if (isAge) {
      label = label.replace('Date', 'Age').replace('date', 'age');
    }
  }

  const currentMoment = dateValue ? moment(dateValue) : undefined;
  return {
    label,
    onChange: onYearChange,
    value: currentMoment ? currentMoment.diff(startDate, 'years') : undefined,
  };
}
